import { msg } from '@lingui/macro';
import { IconLink } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productExternalIdImport',
  status: 'active',
  category: 'master-list',
  icon: IconLink,
  title: msg`Master list external IDs`,
  shortTitle: msg`Master list external IDs`,
  whenToUse: msg`Update the external IDs of products in the master list.`,
  outputDescription: msg`Updates external IDs on products in the master list.`,
  intents: [
    'Update external IDs on the master list',
    'Refresh supplier-list codes',
    'Re-link master list products to the ERP',
  ],
  keywords: [
    'external ID',
    'master list',
    'code',
    'link',
    'sync',
    'identifier',
  ],
  synonyms: ['GTIN', 'EAN', 'SKU'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: ['Master list ID', 'External ID'],
    requiredColumns: ['Master list ID', 'External ID'],
  },
};

export default descriptor;
